import React, { useEffect, useState } from 'react';
import { makeStyles, MuiThemeProvider } from '@material-ui/core/styles';
// import classNames from 'classnames';
import { Button, Typography, Modal } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch, useSelector } from 'react-redux';
import PoslumaNavBar from '../../../micro/BrandNavBar/PoslumaNavBar';
import TrainingNavBar from '../../../micro/TrainingNavBar/PoslumaTrainingNavBar';
import { BASE_URL, IMAGE_PATHS } from '../../../../constants/paths.constants';
import { poslumaBox, poslumaDarkGrey, white, poslumaDarkBlue, poslumaTheme } from '../../../../app/theme';
import Indication from '../../../micro/Indication/PoslumaIndication';
import TrainingFooter from '../../../micro/TrainingFooter/TrainingFooter';
import { BASE_ROUTE } from '../../../../constants/trainingNav.constants';
import history from '../../../../services/browserHistory';
import IndicationContent from '../../../micro/Indication/PoslumaIndicationContent';
import AppState from '../../../../models/redux/state/app.state';
import { setSeenISILocal } from '../../../../redux/actions/auth/auth.actions';

const useStyles = makeStyles(() => ({
  grayBox: {
    backgroundColor: poslumaDarkGrey,
  },
  welcomeImage: {
    display: 'block',
    width: '100%',
  },
  linkContainer: {
    display: 'flex',
    gap: '0px 22px',
    paddingTop: 32,
    paddingBottom: 48,
    paddingLeft: 64,
    paddingRight: 64,
  },
  poslumaBox: {
    backgroundColor: poslumaBox,
    width: '100%',
    paddingTop: 26,
    paddingBottom: 40,
    paddingLeft: 39,
    paddingRight: 36,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  iconImages: {
    height: 80,
  },
  titleText: {
    marginTop: 16,
    marginBottom: 0,
  },
  subheaderText: {
    color: white,
    fontSize: 20,
    fontWeight: 500,
  },
  thumbnailImages: {
    width: '100%',
    marginTop: 16,
    marginBottom: 32,
  },
  combinedTexts: {
    display: 'flex',
  },
  boldText: {
    fontSize: 18,
    color: white,
    fontWeight: 600,
    fontStyle: 'italic',
  },
  bodyText: {
    fontSize: 18,
    color: white,
  },
  secondParagraph: {
    marginTop: 16,
  },
  enterButton: {
    marginTop: 32,
    width: 132,
    fontSize: 16,
    fontWeight: 600,
    borderRadius: 24,
  },
  modalContainer: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modal: {
    maxWidth: '80%',
    padding: '2em',
    position: 'relative',
    boxSizing: 'border-box',
    backgroundColor: white,
    borderRadius: 5,
    maxHeight: '80vh',
    overflowX: 'auto',
  },
  closeButton: {
    position: 'absolute',
    top: '0.25em',
    right: '0.25em',
  },
  resourcesContainer: {
    backgroundColor: white,
    padding: '50px 64px 10px',
    display: 'flex',
    flexDirection: 'row',
  },
  resourcesTitle: {
    color: poslumaDarkBlue,
    fontSize: 24,
    letterSpacing: 1.6,
  },
  iconImage: {
    width: 'auto',
    height: 80,
    marginRight: 20,
  },
  link: {
    fontWeight: 'bold',
    color: poslumaDarkBlue,
    textDecoration: 'underline',
  },
}));

const TrainingHome = (): JSX.Element => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const hasSeenISI = useSelector((state: AppState) => state.auth.hasSeenISI);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(true);

  useEffect(() => {
    document.title = 'Welcome to POSLUMA Training';
  }, []);

  useEffect(() => {
    setIsModalOpen(!hasSeenISI);
  }, [hasSeenISI]);

  const handleCloseModal = () => {
    dispatch(setSeenISILocal(true));
  };

  const handleClickEnter = (module: string) => {
    const baseRoute = BASE_ROUTE[module];
    history.push(baseRoute);
  };

  return (
    <MuiThemeProvider theme={poslumaTheme}>
      {/* Gray Nav Bar */}
      <TrainingNavBar />

      {/* Note: This pattern should not be duplicated; it is an unusual component that
       needs to use the CSS relative and absolute.
       */}
      <div>
        {/* POSLUMA Nav Bar */}
        <PoslumaNavBar section="Home" />

        <div>
          {/* Top Block */}
          {/* <div>Top images?</div> */}
          <img
            className={classes.welcomeImage}
            src={`${BASE_URL}${IMAGE_PATHS.HOME_PAGE[2].WELCOME_IMAGE.path}`}
            alt={`${IMAGE_PATHS.HOME_PAGE[2].WELCOME_IMAGE.alt}`}
          />

          {/* Link Block */}
          <div className={classes.grayBox}>
            <div className={classes.linkContainer}>
              <div className={classes.poslumaBox}>
                <div>
                  <img
                    className={classes.iconImages}
                    src={`${BASE_URL}${IMAGE_PATHS.HOME_PAGE[2].IMAGE_ACQUISITION_ICON.path}`}
                    alt={`${IMAGE_PATHS.HOME_PAGE[2].IMAGE_ACQUISITION_ICON.alt}`}
                  />
                  <Typography variant="h6" className={classes.titleText}>
                    NUCLEAR MEDICINE TECHNOLOGIST
                  </Typography>
                  <Typography className={classes.subheaderText}>Image Acquisition Training</Typography>
                  <img
                    className={classes.thumbnailImages}
                    src={`${BASE_URL}${IMAGE_PATHS.HOME_PAGE[2].IMAGE_ACQUISITION_THUMBNAIL.path}`}
                    alt={`${IMAGE_PATHS.HOME_PAGE[2].IMAGE_ACQUISITION_THUMBNAIL.alt}`}
                  />
                  <span>
                    <Typography display="inline" className={classes.boldText}>
                      Intended for technologists
                    </Typography>
                    <Typography display="inline" className={classes.bodyText}>
                      &nbsp;to understand the dosing and administration of POSLUMA, with a focus on optimizing the image
                      acquisition protocol.
                    </Typography>
                  </span>
                  <div className={classes.secondParagraph}>
                    <Typography className={classes.bodyText}>
                      Once the recommended training is completed, clinical case studies will be available. The
                      <i> Nuclear Medicine Physician: Image Interpretation Training </i>
                      track can also be accessed for additional content or information.
                    </Typography>
                  </div>
                </div>
                <div>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.enterButton}
                    onClick={() => handleClickEnter('poslumaAcquisition')}
                  >
                    Enter
                  </Button>
                </div>
              </div>

              <div className={classes.poslumaBox}>
                <div>
                  <img
                    className={classes.iconImages}
                    src={`${BASE_URL}${IMAGE_PATHS.HOME_PAGE[2].IMAGE_INTERPRETATION_ICON.path}`}
                    alt={`${IMAGE_PATHS.HOME_PAGE[2].IMAGE_INTERPRETATION_ICON.alt}`}
                  />
                  <Typography variant="h6" className={classes.titleText}>
                    NUCLEAR MEDICINE PHYSICIAN
                  </Typography>
                  <Typography className={classes.subheaderText}>Image Interpretation Training</Typography>
                  <img
                    className={classes.thumbnailImages}
                    src={`${BASE_URL}${IMAGE_PATHS.HOME_PAGE[2].IMAGE_INTERPRETATION_THUMBNAIL.path}`}
                    alt={`${IMAGE_PATHS.HOME_PAGE[2].IMAGE_INTERPRETATION_THUMBNAIL.alt}`}
                  />
                  <span>
                    <Typography display="inline" className={classes.boldText}>
                      Intended for physicians
                    </Typography>
                    <Typography display="inline" className={classes.bodyText}>
                      &nbsp;to understand the image acquisition and interpretation criteria for POSLUMA.
                    </Typography>
                  </span>
                  <div className={classes.secondParagraph}>
                    <Typography className={classes.bodyText}>
                      Once the recommended training is completed, clinical case studies will be available.
                    </Typography>
                  </div>
                </div>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.enterButton}
                  onClick={() => handleClickEnter('poslumaInterpretation')}
                >
                  Enter
                </Button>
              </div>
            </div>
          </div>
          <div className={classes.resourcesContainer}>
            <img
              src={`${BASE_URL}${IMAGE_PATHS.POSLUMA_DOWNLOADABLE_RESOURCES_ICON.path}`}
              alt={IMAGE_PATHS.POSLUMA_DOWNLOADABLE_RESOURCES_ICON.alt}
              className={classes.iconImage}
            />
            <div>
              <Typography className={classes.resourcesTitle}>DOWNLOADABLE RESOURCES</Typography>
              <Typography variant="body1">
                <b>
                  Intended for nuclear medicine physicians, technologists, and health care professionals in related
                  fields
                </b>
              </Typography>
              <Typography variant="body1">
                Visit the&nbsp;
                <a href="/posluma/downloadableresources" className={classes.link}>
                  Downloadable Resources
                </a>
                &nbsp;section for additional information and documents.
              </Typography>
            </div>
          </div>

          <Indication />
          <TrainingFooter />
        </div>
      </div>
      <Modal open={isModalOpen} onClose={handleCloseModal} disableBackdropClick disableEscapeKeyDown>
        <div className={classes.modalContainer}>
          <div className={classes.modal}>
            <IconButton aria-label="close" className={classes.closeButton} onClick={handleCloseModal}>
              <CloseIcon />
            </IconButton>
            <IndicationContent isOpen />
          </div>
        </div>
      </Modal>
    </MuiThemeProvider>
  );
};

export default TrainingHome;
